import { createFileRoute } from '@tanstack/react-router';
import PageWrapper from 'src/components/PageWrapper/PageWrapper';
import PastMarketInformationPage from '../pages/PastMarketInformation/PastMarketInformation';

export const Route = createFileRoute('/past-market-information')({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <PageWrapper title="All market information" description="Download data for a trading zone">
      <PastMarketInformationPage />
    </PageWrapper>
  );
}
